// extracted by css-extract-rspack-plugin
export default {"subPanel":"SubPanel__subPanel--P8sAJ PrimaryPanel__base--p1Qe6","subHeadding":"SubPanel__subHeadding--C74GJ PrimaryPanel__heading--omx5_"};